// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IEmailIllustrationDto
 */
export interface IEmailIllustrationDto {
    /**
     * 
     * @type {number}
     * @memberof IEmailIllustrationDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof IEmailIllustrationDto
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof IEmailIllustrationDto
     */
    image_path?: string;
}

/**
 * Check if a given object implements the IEmailIllustrationDto interface.
 */
export function instanceOfIEmailIllustrationDto(value: object): value is IEmailIllustrationDto {
    return true;
}

export function IEmailIllustrationDtoFromJSON(json: any): IEmailIllustrationDto {
    return IEmailIllustrationDtoFromJSONTyped(json, false);
}

export function IEmailIllustrationDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IEmailIllustrationDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'image_path': json['image_path'] == null ? undefined : json['image_path'],
    };
}

export function IEmailIllustrationDtoToJSON(json: any): IEmailIllustrationDto {
    return IEmailIllustrationDtoToJSONTyped(json, false);
}

export function IEmailIllustrationDtoToJSONTyped(value?: IEmailIllustrationDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'image_path': value['image_path'],
    };
}

